import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import { useCallback } from "react";
import { Engine } from "tsparticles-engine";

const ParticlesCompo = () => {
  const particlesInit = useCallback(async (engine: Engine) => {
    // console.log(engine);
    await loadFull(engine);
  }, []);

  const particlesLoaded = useCallback(async (container: any) => {
    await container;
  }, []);

  return (
    <>
      <Particles
        className="particals-block"
        init={particlesInit}
        loaded={particlesLoaded}
        options={{
          background: {
            color: {
              value: "transparent",
            },
          },
          // fpsLimit: 0,
          interactivity: {
            events: {
              onClick: {
                enable: true,
                mode: "push",
              },
              onHover: {
                enable: true,
                mode: "repulse",
              },
              resize: true,
            },
            modes: {
              push: {
                quantity: 1,
              },
              repulse: {
                distance: 50,
                duration: 0.4,
              },
            },
          },
          style: {
            width: "100%",
            height: "100%",
            position: "absolute",
            top: "0",
            left: "0",
          },
          particles: {
            color: {
              value: "#cdcccc",
            },
            links: {
              color: "#363535",
              distance: 120,
              enable: true,
              opacity: 0.5,
              width: 0.5,
            },
            collisions: {
              enable: true,
            },
            move: {
              enable: true,
              outModes: {
                default: "bounce",
              },
              random: true,
              speed: 1.3,
              straight: false,
            },
            number: {
              density: {
                enable: true,
                area: 900,
              },
              value: 102,
            },
            opacity: {
              value: 0.5,
            },
            shape: {
              type: "circle",
            },
            size: {
              value: { min: 0.5, max: 2.5 },
            },
          },
          detectRetina: true,
        }}
      />
    </>
  );
};

export default ParticlesCompo;
